export enum HolidayChildCareType {
  DailyHoliday = 1,
  HourlyHoliday = 2
}
